import { Collapse as AntdCollapse } from 'antd'
import _ from 'lodash'
import { useState, ReactNode, FunctionComponent } from 'react'
import styled from 'styled-components'

const { Panel } = AntdCollapse

type ColProps = {
  renderHeader: (opened: boolean, disabled?: boolean) => ReactNode
  defaultOpen?: boolean
  disabled?: boolean
  onChanged?: (opened: boolean) => void
  style?: React.CSSProperties
}

const StyledPanel = styled(Panel)`
  .ant-collapse-header {
    padding: 0 !important;
  }

  .ant-collapse-content-box {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`
export const CollapseContent: FunctionComponent<ColProps> = ({
  renderHeader,
  defaultOpen,
  children,
  disabled,
  onChanged,
  style
}) => {
  const [open, setOpen] = useState(defaultOpen || false)

  return (
    <AntdCollapse
      ghost
      activeKey={open ? '1' : undefined}
      onChange={key => {
        if (disabled) return
        const newOpen = !_.isEmpty(key)
        setOpen(newOpen)
        onChanged && onChanged(newOpen)
        return
      }}
      collapsible={disabled ? 'disabled' : undefined}
      style={style}
    >
      <StyledPanel header={renderHeader(open, disabled)} key="1" showArrow={false}>
        {children}
      </StyledPanel>
    </AntdCollapse>
  )
}
